import { useEffect } from "react";

const StudentReferralForm = () => {
    useEffect(() => {
        if (!document.querySelector('script[src="https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js';
            script.setAttribute('data-widget-id', 'e334f667-cdbe-11ef-b491-02eda0793197');
            script.setAttribute('data-version-id', 'd6ab2565-be81-446a-93b3-02efd7b01c20');
            script.setAttribute('data-formjs', 'https://forms.lsqportal.com/r21/js/lsq.form.js');
            script.setAttribute('data-URL', 'https://portal-widgets.lsqportal.com');
            script.setAttribute('onload', "window['___lsq-portal-widget-helpers___'].bootstrapLSQWidget(event)");
            script.Charset = 'utf-8';
        
            // Append the script to the div with id "sd"
            const widgetDiv = document.getElementById('lsq-portal-widget-e334f667-cdbe-11ef-b491-02eda0793197-d6ab2565-be81-446a-93b3-02efd7b01c20');
            if (widgetDiv) {
                widgetDiv.appendChild(script);
            }
        }
    }, []);

    return (
        <div id="lsq-portal-widget-e334f667-cdbe-11ef-b491-02eda0793197-d6ab2565-be81-446a-93b3-02efd7b01c20" className="lsq-portal-widget lsq-form-widget">
        </div>
    )
}
export default StudentReferralForm;